import { create } from 'zustand';

interface AppState {
  toast: { message: string, type: 'success' | 'error' | 'info' } | null;
  setToast: (toast: { message: string, type: 'success' | 'error' | 'info' } | null) => void;
}

export const useAppStore = create<AppState>()((set) => ({
  toast: null,
  setToast: (toast) => { set({ toast }); },
}));
